import { notification } from "antd";
import { get } from "lodash";
import moment from "moment";
import { MdCloudDownload, MdSend } from "react-icons/md";
import Alert from "shared/components/Alert";
import Button from "shared/components/Button";
import { useLazyQuery, useMutation } from "shared/hooks/useApi";
import { useScreenActionPermissions } from "shared/hooks/usePermissions";
import format from "string-template";
import { SEND_TO_MANAGEMENT } from "utils/api/graphql/mutations/subscription";
import { GET_MANAGEMENT_ATTACHMENTS } from "utils/api/graphql/queries/subscription";
import {
  ACTIONS,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  MODULES,
  SUBMODULES,
} from "utils/constants";
import { downloadDocument } from "utils/helpers/files";

const Signed = ({ translation, subscription, percentages }) => {
  const lastSentToManagement = get(
    subscription,
    "externalManagement.lastSentToManagement",
  );
  const actions = useScreenActionPermissions({
    module: MODULES.SUBSCRIPTION,
    submodule: SUBMODULES.BROKER_DETAIL,
  });

  const [sendToManagement, { loading }] = useMutation(SEND_TO_MANAGEMENT, {
    onCompleted: () => {
      notification.success({
        message: translation.SEND_TO_MANAGEMENT_SUCCESS,
        duration: 5,
      });
    },
    onError: (error) => {
      notification.error({
        message: error.message,
        duration: 5,
      });
    },
  });

  const [getManagementAttachments, { loading: downloading }] = useLazyQuery(
    GET_MANAGEMENT_ATTACHMENTS,
    {
      onCompleted: ({ getManagementAttachments: result }) => {
        if (result) {
          downloadDocument(result);
        }
      },
      onError: (error) => {
        notification.error({
          message: error.message,
          duration: 5,
        });
      },
      fetchPolicy: "no-cache",
    },
  );

  const handleSendToManagement = () => {
    sendToManagement({
      variables: {
        where: { id: subscription.id },
      },
    });
  };

  const handleDownloadAttachments = () => {
    getManagementAttachments({
      variables: {
        where: { id: subscription.id },
      },
    });
  };

  return (
    <div className="grid--1">
      <div className="signature_signed">
        <span>{`${translation.E_SIGNATURE_SIGNED} ${moment(
          subscription.signedDate,
        ).format(DATE_FORMAT)}`}</span>
        <br />
        <br />
      </div>
      {lastSentToManagement && (
        <>
          <Alert
            showIcon
            type="info"
            message={format(translation.SEND_TO_MANAGEMENT_ALREADY_SENT, {
              date: moment(lastSentToManagement).format(DATE_TIME_FORMAT),
            })}
          />
        </>
      )}
      {!get(actions, ACTIONS.SEND_TO_MANAGEMENT) && (
        <>
          <Alert
            showIcon
            type="warning"
            message={translation.SEND_TO_MANAGEMENT_FORBIDDEN}
          />
        </>
      )}
      <div className="grid--2">
        <Button
          type="primary--outlined"
          onClick={handleSendToManagement}
          loading={loading}
          disabled={
            loading ||
            !get(actions, ACTIONS.SEND_TO_MANAGEMENT) ||
            !get(actions, ACTIONS.SEND_TO_MANAGEMENT) ||
            percentages?.proofPercentage < 100 ||
            percentages?.additionalInfoPercentage < 100
          }
          block
        >
          {translation.SEND_TO_MANAGEMENT}
          <MdSend size={16} style={{ marginLeft: 8 }} />
        </Button>
        <Button
          type="primary"
          onClick={handleDownloadAttachments}
          loading={downloading}
          disabled={downloading || !get(actions, ACTIONS.SEND_TO_MANAGEMENT)}
          block
        >
          {translation.DOWNLOAD_MANAGEMENT_ATTACHMENTS ||
            "Download attachments"}
          <MdCloudDownload size={16} style={{ marginLeft: 8 }} />
        </Button>
      </div>
    </div>
  );
};

export default Signed;
